import { useContext } from "react";

import { DocumentsContext } from "../context";

function useDocumentsContext() {
  return useContext(DocumentsContext);
}

export default useDocumentsContext;
